import {Button} from '@miro-site/core'

import type {LinkProps as LinkPropsBase} from '@miro-site/core'

import styled, {css} from 'styled-components'

export interface LinkProps extends LinkPropsBase {
  $isDashed?: boolean
}

const SecondaryLink = styled(Button)<LinkProps>`
  ${({theme}) =>
    theme.normalizeStyles({
      color: theme.templates.colors.secondary40,
      ':focus': {
        ...theme.focus.outlines.withOffset,
      },

      fontSize: 14,
      lineHeight: 20,
    })}

  ${({$isDashed}) =>
    $isDashed
      ? css`
          border-bottom: 1px dashed currentColor;
          transition: border-color 250ms ease 0s;

          &:hover {
            border-color: transparent;
          }
        `
      : css`
          border-color: transparent;

          &:hover {
            border-color: transparent;
          }
        `}
`

export default SecondaryLink
